export default {
    createTicket: () => "/supportTicket",
    getAllTickets: () => "/supportTicket",
    uploadFile: (id) => `/fbUpload/images/${id}`,
    getUserTickets: (userId) => `/supportTicket/user/${userId}`,
    getTicketById: (ticketId) => `/supportTicket/${ticketId}`,
    replyToTicket: (ticketId) => `/supportTicket/${ticketId}`,
    GETALLBOARD: () => '/board/getAllBoardData',
    SELECTED_BOARD: (id) => `/boardList/getBoardListByboardId/${id}`,
    GET_BOARD_USERS: () => '/userBoard/allUser',
    UPDATE_TICKET: (ticketId) => `/supportTicket/${ticketId}`
};
